// Mock data for products and content

export const products = [
  {
    id: 1,
    name: "Wireless Earbuds Pro",
    name_tr: "Kablosuz Kulaklık Pro",
    brand: "YurtTech",
    price: 89,
    currency: "€",
    image: "/images/1.jpg",
    category: "audio",
    featured: true
  },
  {
    id: 2,
    name: "Pulse Oximeter",
    name_tr: "Pulse Oksimetre",
    brand: "YurtTech",
    price: 45,
    currency: "€",
    image: "/images/2.jpg",
    category: "health",
    featured: true
  },
  {
    id: 3,
    name: "Power Bank 10000mAh",
    name_tr: "Taşınabilir Şarj Cihazı 10000mAh",
    brand: "YurtTech",
    price: 39,
    currency: "€",
    image: "/images/3.jpg",
    category: "accessories",
    featured: true
  },
  {
    id: 4,
    name: "Smartphone Gimbal Stabilizer",
    name_tr: "Akıllı Telefon Gimbal Sabitleyici",
    brand: "AudioMax",
    price: 129,
    currency: "€",
    image: "/images/4.jpg",
    category: "camera",
    featured: true
  },
  {
    id: 5,
    name: "AI Smart Projector",
    name_tr: "Taşınabilir Akıllı Projektör",
    brand: "PowerBook Gaming",
    price: 699,
    currency: "€",
    image: "/images/5.jpg",
    category: "home",
    featured: true
  },
  {
    id: 6,
    name: "Aroma Diffuser & Humidifier",
    name_tr: "Aroma Difüzör & Nemlendirici",
    brand: "WearTech",
    price: 59,
    currency: "€",
    image: "/images/6.jpg",
    category: "home",
    featured: true
  }
];

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      contact: "Contact"
    },
    hero: {
      title: "welcome to the future of technology...",
      subtitle: "Discover cutting-edge tech products that power your digital lifestyle",
      cta: "Explore Products"
    },
    products: {
      title: "Featured Products",
      subtitle: "Premium technology devices carefully selected for you"
    },
    values: {
      quality_title: "Premium Quality",
      quality_desc: "Only authentic products from trusted brands with warranty",
      delivery_title: "Fast Delivery",
      delivery_desc: "Quick and secure shipping with real-time tracking",
      support_title: "Customer Support",
      support_desc: "24/7 expert support and technical assistance for all products"
    },
    team: {
      title: "Our Technology Experts",
      subtitle: "Our team of technology experts and enthusiasts work tirelessly to bring you products that truly make a difference. We believe in the power of innovation and cutting-edge technology.",
      expert_title: "Expert Team",
      expert_desc: "Years of experience in technology and innovation",
      quality_title: "Quality First",
      quality_desc: "Rigorous testing and quality control",
      customer_title: "Customer Care",
      customer_desc: "Dedicated to your satisfaction"
    },
    about: {
      hero_title: "About Our Story",
      hero_subtitle: "Empowering lives through innovative technology",
      section1_title: "Our Mission",
      section1_content: "We are dedicated to bringing you the latest and most innovative technology products. Our carefully curated collection combines cutting-edge innovation with reliability to deliver exceptional performance and user experience.",
      section2_title: "Our Vision",
      section2_content: "We believe that technology should enhance and simplify life. Our vision is to make premium tech products accessible to everyone, offering devices that combine performance, design, and value to empower your digital journey.",
      section3_title: "Our Values",
      values: [
        "Innovation: Latest technology and cutting-edge features",
        "Quality: Only premium brands and reliable products",
        "Customer Focus: Exceptional service and support",
        "Sustainability: Eco-friendly packaging and responsible sourcing"
      ]
    },
    contact: {
      title: "Get in Touch",
      subtitle: "We'd love to hear from you",
      form: {
        name: "Your Name",
        email: "Email Address",
        phone: "Phone Number",
        message: "Your Message",
        submit: "Send Message"
      },
      info: {
        title: "Contact Information",
        address: "Address",
        address_value: "30N GOULD ST STE 3981 SHERIDAN WY 82801 USA",
        phone: "Phone",
        phone_value: "+31 10 123 4567",
        email: "Email",
        email_value: "info@yurttech.net",
        hours: "Business Hours",
        hours_value: "Mon - Sat: 10:00 - 20:00"
      }
    },
    footer: {
      tagline: "Premium technology products for your digital lifestyle",
      rights: "All rights reserved."
    }
  },
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      products: "Ürünler",
      contact: "İletişim"
    },
    hero: {
      title: "teknolojinin geleceğine hoş geldiniz...",
      subtitle: "Dijital yaşam tarzınızı güçlendiren son teknoloji ürünleri keşfedin",
      cta: "Ürünleri Keşfet"
    },
    products: {
      title: "Öne Çıkan Ürünler",
      subtitle: "Sizin için özenle seçilmiş premium teknoloji cihazları"
    },
    values: {
      quality_title: "Premium Kalite",
      quality_desc: "Garantili, güvenilir markalardan sadece orijinal ürünler",
      delivery_title: "Hızlı Teslimat",
      delivery_desc: "Gerçek zamanlı takip ile hızlı ve güvenli kargo",
      support_title: "Müşteri Desteği",
      support_desc: "Tüm ürünler için 7/24 uzman destek ve teknik yardım"
    },
    team: {
      title: "Teknoloji Uzmanlarımız",
      subtitle: "Teknoloji uzmanları ve tutkunlarından oluşan ekibimiz, gerçekten fark yaratan ürünleri size sunmak için yorulmadan çalışıyor. İnovasyonun ve son teknolojinin gücüne inanıyoruz.",
      expert_title: "Uzman Ekip",
      expert_desc: "Teknoloji ve inovasyon alanında yılların deneyimi",
      quality_title: "Kalite Önceliğimiz",
      quality_desc: "Titiz test ve kalite kontrol",
      customer_title: "Müşteri Hizmetleri",
      customer_desc: "Memnuniyetinize adanmış"
    },
    about: {
      hero_title: "Hikayemiz",
      hero_subtitle: "Yenilikçi teknolojiyle hayatları güçlendirmek",
      section1_title: "Misyonumuz",
      section1_content: "Size en yeni ve en yenilikçi teknoloji ürünlerini sunmaya kendimizi adadık. Özenle seçilmiş koleksiyonumuz, olağanüstü performans ve kullanıcı deneyimi sunmak için son teknoloji inovasyonu güvenilirlikle birleştiriyor.",
      section2_title: "Vizyonumuz",
      section2_content: "Teknolojinin hayatı kolaylaştırması ve geliştirmesi gerektiğine inanıyoruz. Vizyonumuz, premium teknoloji ürünlerini herkese erişilebilir kılmak, dijital yolculuğunuzu güçlendirecek performans, tasarım ve değeri birleştiren cihazlar sunmaktır.",
      section3_title: "Değerlerimiz",
      values: [
        "İnovasyon: En son teknoloji ve son teknoloji özellikler",
        "Kalite: Sadece premium markalar ve güvenilir ürünler",
        "Müşteri Odaklılık: Olağanüstü hizmet ve destek",
        "Sürdürülebilirlik: Çevre dostu ambalaj ve sorumlu tedarik"
      ]
    },
    contact: {
      title: "İletişime Geçin",
      subtitle: "Sizden haber almak isteriz",
      form: {
        name: "Adınız",
        email: "E-posta Adresi",
        phone: "Telefon Numarası",
        message: "Mesajınız",
        submit: "Mesaj Gönder"
      },
      info: {
        title: "İletişim Bilgileri",
        address: "Adres",
        address_value: "30N GOULD ST STE 3981 SHERIDAN WY 82801 ABD",
        phone: "Telefon",
        phone_value: "+31 10 123 4567",
        email: "E-posta",
        email_value: "info@yurttech.net",
        hours: "Çalışma Saatleri",
        hours_value: "Pzt - Cmt: 10:00 - 20:00"
      }
    },
    footer: {
      tagline: "Dijital yaşam tarzınız için premium teknoloji ürünleri",
      rights: "Tüm hakları saklıdır."
    }
  }
};